import { SVGProps } from 'react';

/**
 * Double speech-bubble quotation mark for the "Add to Chronology" buttons: first glyph
 * outlined, second filled, both on `currentColor`. Height follows the viewBox (16×~13).
 */
export const QuoteOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="16" viewBox="0 0 191 157" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M85 7C95.4934 7 104 15.5066 104 26V85.1807C104 89.0572 102.814 92.8412 100.602 96.0244L69.9395 140.141C59.666 155.853 35.3653 143.411 42.2305 125.827L51.6396 101.728C52.7259 98.9453 50.6732 95.9414 47.6865 95.9414H26C15.5067 95.9414 7.00012 87.4347 7 76.9414V26C7 15.5066 15.5066 7 26 7H85Z"
        stroke="currentColor"
        strokeWidth="14"
      />
      <path
        d="M164.094 2C178.453 2 190.094 13.6406 190.094 28V87.1807C190.094 92.4854 188.471 97.6636 185.443 102.02L154.82 146.079C139.925 168.662 104.888 150.68 114.804 125.281L122.745 104.941H117.085C119.697 100.678 121.333 95.8965 121.885 90.9414H126.78C134.695 90.9414 140.132 98.9012 137.254 106.273L127.845 130.373C124.032 140.139 137.585 147.04 143.239 138.212L173.947 94.0293C175.257 92.1444 175.998 89.926 176.085 87.6387L176.094 87.1807V28C176.094 21.4761 170.888 16.1681 164.403 16.0039L164.094 16H119.913C117.844 10.5174 114.4 5.71098 110 2H164.094Z"
        fill="currentColor"
      />
    </svg>
  );
};
